import { AppFeeDetailsSectionCombinedProps } from './types';

const usePresenter = (props: AppFeeDetailsSectionCombinedProps): AppFeeDetailsSectionCombinedProps => {
  return props;
};

export default usePresenter;
